import { Component } from '@angular/core';

// Modal for chat-related admin/dev settings, opened from the rail's Settings
// sub-item. Currently holds only the LangGraph instance selector.
@Component({
  selector: 'app-chat-settings-dialog',
  templateUrl: './chat-settings-dialog.component.html',
  standalone: false,
})
export class ChatSettingsDialogComponent {}
